"use client";
import AppLayout from "@/components/app/applayout";
import { makeStyles } from "tss-react/mui";
import { Box, IconButton, Typography } from "@mui/material";
import Hero from "@/components/about/hero";
import Mission from "@/components/about/mission";
import AboutDesign from "@/components/about/aboutDesign";
import { pxToRem, AppSize } from "@/util";
import { AppColors } from "@/assets/colors";
import { aboutSections } from "@/util/data/about";
import MissionCard from "@/components/about/missionCard";
import Image from "next/image";
import InstagramIcon from "@mui/icons-material/Instagram";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { AboutCarousel } from "@/components/about/carousel";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import Link from "next/link";

export default function About() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Box className={classes.container}>
        <Hero />
        <Mission />
        <Box className={classes.aboutCardCont}>
          {aboutSections.map((value, key) => {
            return <MissionCard {...value} key={key} />;
          })}
        </Box>
        <Box className={classes.abtCont}>
          <AboutCarousel>
            {aboutSections.map((value, key) => {
              return <MissionCard {...value} key={key} />;
            })}
          </AboutCarousel>
        </Box>

        <Box className={classes.aboutCont}>
          <AboutDesign />
        </Box>
        <Box className={classes.team}>
          <Typography className={classes.teamHeading}>
            Meet Our <span className={classes.teamSpan}>Managing Director</span>
          </Typography>

          <Box className={classes.teamBox}>
            <Box className={classes.imgCont}>
              <Image
                src={"/images/about/Ebuzoeme.svg"}
                className={classes.img}
                alt="Engr"
                fill
              />
            </Box>
            <Box className={classes.imgDet}>
              <Box>
                <Typography className={classes.engrName}>
                  Engr. Macdonald Ebuzoeme
                </Typography>
                <Typography className={classes.engrDetail}>
                  Managing Director, AREL
                </Typography>
              </Box>
              <Box>
                <Typography className={`${classes.engrDetail}`}>
                  Engr. Macdonald brings over 10 years of experience in real
                  estate development, urban planning, and investment strategy.
                  Under his leadership, AREL has grown into a forward-thinking
                  brand focused on quality, innovation, and investor trust.
                </Typography>
                <Typography className={`${classes.detTxt}`}>
                  “We’re not just building properties — we’re creating long-term
                  value for our clients and transforming communities.”
                </Typography>
              </Box>
              <Box className={classes.socialIcons}>
                <IconButton>
                  <Link href="https://wa.me/2349063157836" target="_blank">
                    <WhatsAppIcon className={classes.socialIcon} />
                  </Link>
                </IconButton>

                {/* <IconButton>
                  <LinkedInIcon className={classes.socialIcon} />
                </IconButton> */}

                <IconButton>
                  <Link
                    href="https://www.instagram.com/arel_homes/?igsh=Yzkwc2E4Y3NkbjN3&utm_source=qr#"
                    target="_blank"
                  >
                    <InstagramIcon className={classes.socialIcon} />
                  </Link>
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>

        {/*
        
         {team.map((team, index) => (
              <Team
                key={index}
                image={team.image}
                name={team.name}
                position={team.position}
                role={team.role}
                twitter={team.twitter}
                linkedin={team.linkedin}
                instagram={team.instagram}
              />
            ))}
        <Box className={classes.media}>
     <Typography className={classes.blogHeading}>Blog</Typography>
        <Box className={classes.blog}>
          {blog.map((blog, index) => (
            <Blog
              key={index}
              title={blog.title}
              description={blog.description}
              image={blog.image}
            />
          ))}
        </Box>
     </Box> */}
      </Box>
    </AppLayout>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    //gap: theme.spacing(4),
  },
  teamBox: {
    display: "grid",
    gridTemplateColumns: "1.5fr 3.5fr",
    minHeight: pxToRem(500),
    width: "100%",
    gap: theme.spacing(4),
    [theme.breakpoints.down(1023)]: {
      gridTemplateColumns: "2fr 3fr",
    },
    [theme.breakpoints.down(945)]: {
      gridTemplateColumns: "2.5fr 3fr",
    },
    [theme.breakpoints.down(900)]: {
      gridTemplateColumns: "2fr 2fr",
    },
    [theme.breakpoints.down(888)]: {
      gridTemplateColumns: "1fr",
    },
  },
  aboutCont: {
    [theme.breakpoints.down(1200)]: {
      display: "none",
    },
  },
  socialIcons: {},
  socialIcon: {
    height: pxToRem(20),
    width: pxToRem(20),
  },
  img: {
    objectFit: "contain",
    objectPosition: "left", // Changed to prioritize showing the head
    [theme.breakpoints.down("sm")]: {
      objectPosition: "center",
    },
  },
  imgCont: {
    position: "relative",
    width: "100%",
    height: "100%",
    minHeight: pxToRem(400),
    borderRadius: pxToRem(16),
    overflow: "clip",
    display: "flex",
    justifyContent: "flex-start",
  },
  imgDet: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(2)} ${pxToRem(10)}`,
    },
  },
  engrName: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(30),
  },
  engrDetail: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: AppColors.text.second,
    textAlign: "justify",
  },
  detTxt: {
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: pxToRem(16),
    color: AppColors.text.second,
    marginTop: pxToRem(20),
  },
  abtCont: {
    display: "none",
    [theme.breakpoints.down(700)]: {
      marginTop: theme.spacing(3),
      padding: `0px ${pxToRem(20)}`,
      overflow: "hidden",
      position: "relative",
      width: "100%",
      display: "flex",
      height: "100%",
      flex: 1,
    },
  },
  aboutCardCont: {
    marginTop: pxToRem(40),
    padding: `0px ${pxToRem(20)}`,
    display: "none",
    [theme.breakpoints.down(1200)]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gap: theme.spacing(3),
    },
    [theme.breakpoints.down(1024)]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: theme.spacing(3),
      padding: `0px ${pxToRem(30)}`,
    },
    [theme.breakpoints.down(700)]: {
      display: "none",
    },
  },
  blog: {
    display: "flex",
    gap: theme.spacing(4),
  },
  blogHeading: {
    fontFamily: "playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(38),
  },
  teamHeading: {
    fontFamily: "playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(38),
    textAlign: "center",
    width: "80%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  teamSpan: {
    color: AppColors.primary["300"],
  },
  team: {
    marginTop: theme.spacing(4),
    marginBottom: pxToRem(60),
    padding: `0px ${pxToRem(AppSize.padding)}`,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: pxToRem(200),
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(2)} ${pxToRem(20)}`,
    },
  },
  media: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(4),
    padding: `0px ${pxToRem(AppSize.padding)}`,
    width: "100%",
    gap: theme.spacing(3),
  },
}));
